export const DEFAULT_COUNTRY = { id: 1, name: 'Brasil', abbreviation: 'br', ddi: 55 };

export const normalizeText = (value) =>
  value
    ?.toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase() || '';

export const hasCountryValue = (country) =>
  Boolean(
    country &&
      typeof country === 'object' &&
      (country.id || country.name || country.abbreviation),
  );

export const findCountryOption = (countryOptions = [], { abbreviation, name } = {}) => {
  const normalizedAbbreviation = normalizeText(abbreviation);
  const normalizedName = normalizeText(name);

  return (
    countryOptions.find((country) => {
      const optionAbbreviation = normalizeText(country?.abbreviation);
      const optionName = normalizeText(country?.name);

      return (
        (normalizedAbbreviation && optionAbbreviation === normalizedAbbreviation) ||
        (normalizedName && optionName === normalizedName)
      );
    }) || null
  );
};

export const extractCountryNameFromAddress = (addressLike) => {
  const addressText =
    typeof addressLike === 'string'
      ? addressLike
      : addressLike?.formatted_address || addressLike?.address || '';

  if (!addressText) return '';

  const addressParts = addressText
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);

  return addressParts[addressParts.length - 1] || '';
};

export const isCountryConsistentWithAddress = (country, addressLike) => {
  if (!hasCountryValue(country)) return false;

  const addressCountryName = extractCountryNameFromAddress(addressLike);
  if (!addressCountryName) return true;

  const normalizedCountryName = normalizeText(country?.name);
  const normalizedAddressCountryName = normalizeText(addressCountryName);

  return normalizedCountryName === normalizedAddressCountryName;
};

export const enrichPointCountry = async (point = {}, countryOptions = []) => {
  if (
    hasCountryValue(point?.country) &&
    isCountryConsistentWithAddress(point?.country, point)
  ) {
    return point;
  }

  const countryFromAddress = findCountryOption(countryOptions, {
    name: extractCountryNameFromAddress(point),
  });

  if (countryFromAddress) {
    return {
      ...point,
      country: countryFromAddress,
    };
  }

  if (typeof point?.lat !== 'number' || typeof point?.lng !== 'number') {
    return point;
  }

  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${point.lat}&lon=${point.lng}&addressdetails=1`,
    );
    const data = await response.json();
    const matchedCountry = findCountryOption(countryOptions, {
      abbreviation: data?.address?.country_code,
      name: data?.address?.country,
    });

    if (!matchedCountry) return point;

    return {
      ...point,
      country: matchedCountry,
    };
  } catch {
    return point;
  }
};
